// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__GyF1t","icon":"BackToTop_icon__uTGYn"};